import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";

export const QuotaBadge = () => {
  const [u, setU] = useState(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    api.get("/billing/me").then((r) => setU(r.data)).catch(() => {});
  }, [pathname]);

  if (!u) return null;
  const total = u.quota === null ? null : u.quota + u.bonus;
  const out = total !== null && u.used >= total;

  return (
    <button
      data-testid="quota-badge"
      onClick={() => navigate("/billing")}
      title="Monthly allowance"
      className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg border text-xs font-semibold transition-colors ${
        out
          ? "border-destructive/40 bg-destructive/10 text-destructive hover:bg-destructive/15"
          : "border-border text-muted-foreground hover:border-primary/40 hover:text-primary"
      }`}
    >
      <Sparkles className="w-3.5 h-3.5 shrink-0" />
      <span className="font-mono">{u.used}/{total === null ? "∞" : total}</span>
      <span className="font-normal truncate">{u.account_type === "contractor" ? "RFQs" : "auto quotes"}</span>
    </button>
  );
};
